import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=7dc9ebb2"
import script from "./MiniCard.vue?vue&type=script&lang=js"
export * from "./MiniCard.vue?vue&type=script&lang=js"
import style0 from "./MiniCard.vue?vue&type=style&index=0&id=7dc9ebb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports